/** Textes « assurances » — le français fait foi. */
export const assurances = {
  couverture: { tous_risques: 'Tous risques', tiers_plus: 'Tiers plus', tiers: 'Au tiers' } as Record<string, string>,
  policeMaj: 'Police mise à jour.',
  policeEnregistree: "Police enregistrée — l'alerte du menu suit la nouvelle échéance.",
  enregistrementImpossible: 'Enregistrement impossible',
  titre: 'Assurances',
  sousTitre: "Une police par voiture · c'est la franchise qui décide de ce que vous récupérez",
  enregistrerPolice: 'Enregistrer une police',
  sansPolice: (n: number) => `${n} voiture(s) sans police enregistrée`,
  sansPoliceTexte: "— en cas d'accident, personne ne saura quoi appeler ni quelle franchise s'applique.",
  aucune: 'Aucune police enregistrée',
  premiere: 'Enregistrer la première',
  videTexte: "Enregistrez l'assureur, le numéro de police et la franchise de chaque voiture. L'échéance alimente l'alerte du menu, et la franchise sert au calcul d'un sinistre.",
  expireeDepuisCourt: (j: number) => `Expirée depuis ${j} j`,
  joursCourt: (j: number) => `${j} j`,
  police: (n: string, d: string) => `Police ${n} · jusqu'au ${d}`,
  franchiseDe: (m: string) => `Franchise ${m}`,
  col: {
    vehicule: 'Véhicule', assureur: 'Assureur', numero: 'N° de police', couverture: 'Couverture',
    fin: 'Fin de couverture', prime: 'Prime', franchise: 'Franchise',
  },
  expireeDepuis: (j: number) => `expirée depuis ${j} jour(s)`,
  dans: (j: number) => `dans ${j} jour(s)`,
  renouveler: 'Renouveler',
  note: "Renouveler une police archive la précédente et met à jour l'échéance de la voiture : l'alerte du menu suit toute seule.",
  modifierPolice: 'Modifier la police',
  policeAssurance: 'Police d’assurance',
  vehicule: 'Véhicule',
  choisir: '— choisir —',
  assureur: 'Assureur',
  assureurExemple: 'SAA, CAAR, CAAT…',
  agence: 'Agence',
  facultatif: 'Facultatif.',
  numero: 'N° de police',
  couvertureLabel: 'Couverture',
  debut: 'Début de couverture',
  fin: 'Fin de couverture',
  finAide: "C'est cette date qui déclenche l'alerte.",
  prime: (d: string) => `Prime annuelle (${d})`,
  franchise: (d: string) => `Franchise (${d})`,
  franchiseAide: 'Ce qui reste à votre charge sur chaque sinistre.',
  telephone: "Téléphone de l'assureur",
  telephoneAide: "À appeler le jour d'un accident.",
  annuler: 'Annuler',
  enregistrer: 'Enregistrer',
};
